// @flow
import type {Action} from '../../../state/types'

export type SetCitiesPayload = {
  cities: City[],
}

const id = 'hospital/SET_CITIES'

export const setCities = (cities: City[]): Action<SetCitiesPayload> => ({
  type: id,
  payload: {
    cities,
  }
})

setCities.id = id
